import React from "react";
import styled from "styled-components";

interface Props {
  width: number; // 버튼 width
  height: number; // 버튼 height
  source: string;
  onClick?: () => void; // onPress 함수
  disabled?: boolean;
  backgroundStyle?: any;
}

const ImageButton = ({
  width,
  height,
  source,
  onClick,
  disabled,
  backgroundStyle,
}: Props) => {
  return (
    <button
      onClick={() => onClick && onClick()}
      disabled={disabled}
      style={backgroundStyle}
    >
      <StyledImage src={source} width={width} height={height} />
    </button>
  );
};
export default ImageButton;

const StyledImage = styled.img``;
